import { VHost } from "./kotenna/VHost";
import { CloudProvider } from "./kotenna/CloudProvider";
import { Instance } from "./kotenna/Instance";


export interface KuokoFlavour {

    /**
     * **MANDATORY** Call this method **before** any other method invocation!
     *
     * Set the provider that will be used for subsequent requests
     * @param provider
     */
    setProvider(provider: CloudProvider): void;

    /**
     * Perform all the operations required to the specified VHost.
     *
     * It is **REQUIRED** to the implementation to update the VHost definitipn with its ip address using Kotenna /vhost endpoint
     *
     * @param vhost
     * @return vhost {VHost} the Vhost with the ip address set
     */
    startVhost(vhost: VHost): Promise<VHost>;

    /**
     * Perform all the operations required to STOP the specified VHost. instance
     * Generally speaking:
     * 1) Power off instance
     * 2) take snapshot
     * 3) Destroy instance
     *
     * @param vhost
     */
    stopVhost(vhost: VHost): Promise<VHost>;

    /**
     * Return the tpl object required to manage an instance in Porketta
     * @param provider
     * @param instanceId
     */
    generateTpl(instanceId: string): Promise<any>;

    /**
     *
     * @param provider
     * @return {Promise<Instance[]>} List of available instance that can be managed by Porketta
     */
    instances(): Promise<Instance[]>;

}